var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"title":_vm.btn_title_exportCSV,"icon":_vm.icona},on:{"click":_vm.exportCSV}},[_c('v-icon',{attrs:{"color":"success","medium":""}},[_vm._v("mdi-file-table-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }